var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.333,
    height: 37,
    viewBox: "0 0 49.333 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "people",
    d: "M46.25,39a3.02,3.02,0,0,0,3.083-3.083c0-3.083-3.083-12.333-15.417-12.333S18.5,32.833,18.5,35.917A3.02,3.02,0,0,0,21.583,39Zm-24.6-3.083q-.034,0-.068-.012a9.463,9.463,0,0,1,2.343-5.3c1.7-1.995,4.693-3.934,9.99-3.934s8.285,1.942,9.99,3.934a9.494,9.494,0,0,1,2.343,5.3l-.025.006-.043.006Zm12.265-18.5A6.167,6.167,0,1,0,27.75,11.25,6.167,6.167,0,0,0,33.917,17.417Zm9.25-6.167A9.25,9.25,0,1,1,33.917,2a9.25,9.25,0,0,1,9.25,9.25Zm-21.781,13.2a18.13,18.13,0,0,0-3.792-.762q-1.085-.1-2.177-.1C3.083,23.583,0,32.833,0,35.917Q0,39,3.083,39h13a6.9,6.9,0,0,1-.666-3.083,14.15,14.15,0,0,1,3.361-8.954A16.315,16.315,0,0,1,21.386,24.447Zm-6.216,2.22a16.937,16.937,0,0,0-2.837,9.25H3.083A9.461,9.461,0,0,1,5.427,30.6c1.68-1.961,4.6-3.873,9.743-3.931ZM4.625,12.792a9.25,9.25,0,1,1,9.25,9.25A9.25,9.25,0,0,1,4.625,12.792Zm9.25-6.167a6.167,6.167,0,1,0,6.167,6.167A6.167,6.167,0,0,0,13.875,6.625Z",
    transform: "translate(0 -2)",
    fill: "#003082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonas);
export default __webpack_public_path__ + "static/media/personas.32d564f8109e0c5e1017513ec450851a.svg";
export { ForwardRef as ReactComponent };